import React from "react";
import "../css/Omos.css";
import WebGLMap from "./WebGLMap";
import ScrollToTop from "./Tiltop";

export default function Omos() {
  return (
    <div className="omos-container">

      {/* SECTION 1 */}
      <section className="section split">
        <div className="split-text">
          <h2>Hvem er vi</h2>
          <p>
            Linx Legacy Academy er en engageret forening på Frederiksberg,
            dedikeret til at skabe udviklingsmuligheder for unge og voksne
            gennem læring, træning og fællesskab. Vi tilbyder et trygt og
            inspirerende miljø, hvor medlemmer kan udvikle både personlige
            og faglige kompetencer.
          </p>
          <ul>
            <li>
              <strong>Træning og workshops:</strong> Praktiske kurser og træningssessioner
              inden for relevante områder såsom sport, musik, teknologi og lederskab.
            </li>
            <li>
              <strong>Mentoring og coaching:</strong> Personlig vejledning, der hjælper medlemmer
              med at nå deres mål og styrke selvtillid.
            </li>
            <li>
              <strong>Fællesskab:</strong> Sociale aktiviteter og netværk, der fremmer samarbejde
              og venskaber på tværs af alder og baggrund.
            </li>
            <li>
              <strong>Events og projekter:</strong> Mulighed for at deltage i spændende projekter
              og arrangementer, der giver erfaring og udvikling.
            </li>
          </ul>
        </div>

        <div className="split-image">
          <img src="/112.png" alt="Gaming fællesskab" />
        </div>
      </section>

      {/* SECTION 2 */}
      <section className="section light">
        <WebGLMap />
      </section>

      {/* SECTION 3 */}
      <section className="section three-columns">
        <div className="card">
          <h3>Vores Mission</h3>
          <p>
            Vores mission hos Linx Legacy Academy er at skabe et inkluderende og inspirerende
            fællesskab, hvor mennesker kan udvikle deres potentiale, opbygge nye færdigheder
            og støtte hinanden i at nå deres mål. Vi arbejder for at fremme læring,
            samarbejde og personlig udvikling gennem gaming, esport, netværk og fælles initiativer.
          </p>
        </div>

        <div className="card">
          <h3>Vores Vision</h3>
          <p>
            Vores vision er at opbygge et stærkt og bæredygtigt fællesskab, der inspirerer
            mennesker til at vokse, tage initiativ og skabe en positiv forskel i deres liv
            og i samfundet. Vi ønsker at efterlade en varig arv i et miljø, hvor udvikling,
            engagement og fællesskab går hånd i hånd.
          </p>
        </div>
      </section>

      {/* SECTION 4 */}
      <section className="section-container">
        <div className="left-column">
          <div className="story">
            <h2>Vores Historie</h2>
            <p>
              Linx Legacy Academy blev skabt ud fra en vision om at samle mennesker
              omkring læring, udvikling og fællesskab. Det startede som en idé om
              at skabe et sted, hvor mennesker kunne støtte hinanden, dele erfaringer
              og vokse sammen.
            </p>
            <p>
              I dag arbejder vi fortsat for at udvikle et fællesskab, hvor ambitioner
              møder muligheder, og hvor alle kan bidrage til at skabe en stærk og inspirerende fremtid.
            </p>
          </div>
        </div>

        <div className="right-column">
          <div className="values">
            <h2>Vores Kerneværdier</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>Fællesskab</h3>
                <p>Vi skaber et inkluderende miljø, hvor mennesker støtter hinanden og udvikler sig sammen.</p>
              </div>
              <div className="value-card">
                <h3>Udvikling</h3>
                <p>Vi tror på konstant læring og hjælper medlemmer med at udvikle deres potentiale.</p>
              </div>
              <div className="value-card">
                <h3>Respekt</h3>
                <p>Vi bygger vores fællesskab på tillid, åbenhed og respekt for hinandens forskelligheder.</p>
              </div>
              <div className="value-card">
                <h3>Engagement</h3>
                <p>Vi opfordrer alle til at bidrage aktivt og skabe positive initiativer.</p>
              </div>
              <div className="value-card">
                <h3>Ansvar</h3>
                <p>Vi tager ansvar for vores fællesskab og arbejder for en positiv fremtid.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 */}
      <section className="section">
        <h2>Mød vores team</h2>
        <div className="four-columns">
          <div className="kort">
            <img src="/under2.png" alt="Lui" className="team-img" />
            <h4>Lui</h4>
            <p>Formand og team leder</p>
          </div>
          <div className="kort">
            <img src="/under4.png" alt="Jeppe" className="team-img" />
            <h4>Jeppe</h4>
            <p>Næst formand</p>
          </div>
          <div className="kort">
            <img src="/under1.png" alt="Mathias" className="team-img" />
            <h4>Mathias</h4>
            <p>Underviser med pædagogisk erfaring</p>
          </div>
        </div>
      </section>

      {/* SECTION 6 */}
      <section className="kontakt">
        <h2>Kontakt os</h2>
        <p>Email: academy@linxlegacy.dk</p>
      </section>
     <ScrollToTop />
    </div>
  );
}